"use client"
import type { PlanData } from "./types"
import { useTranslations } from "next-intl"
import { RadioCard } from "@/components/generic/RadioCard/RadioCard"
import { useQueryState } from "nuqs"
import { planItemParser } from "../queryStates"
import { useCallback, useMemo } from "react"

export function PlanItem({ displayName, id, description }: PlanData) {
  const [selectedPlan, selectPlan] = useQueryState("plan", planItemParser)

  const t = useTranslations()

  const isSelected = useMemo(() => {
    return selectedPlan === id
  }, [selectedPlan, id])

  const handleClick = useCallback(() => {
    selectPlan(id)
  }, [id, selectPlan])

  return (
    <RadioCard
      checked={isSelected}
      label={t(displayName)}
      description={t(description)}
      onClick={handleClick}
      props={{
        card: {
          styles: {
            card: {
              backgroundColor: "transparent",
            },
          },
        },
      }}
    />
  )

  // return (
  //   <RadioCard className={classes.root} radius="md" value={id}>
  //     <Group wrap="nowrap" align="flex-start">
  //       <RadioIndicator icon={CheckIcon} />
  //       <Box>
  //         <Text size="lg" className={classes.label}>
  //           {t(displayName)}
  //         </Text>
  //         <Text className={classes.description}>{t(description)}</Text>
  //       </Box>
  //     </Group>
  //   </RadioCard>
  // )
}
